import { Mapper } from "../../../../base/utils/mapper";
import { CalculatedFormulaModel } from "../../../../domain/models/consult/calculated-formula.model";
import { CalculatedFormulaEntity } from "../entities/calculated-formula.entity";

export class CalculatedFormulaImplementationRepositoryMapper extends Mapper<CalculatedFormulaEntity, CalculatedFormulaModel> {
    mapFrom(param: CalculatedFormulaEntity): CalculatedFormulaModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: CalculatedFormulaModel): CalculatedFormulaEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}